<template>
    <ul>
        <li> <router-link to="/help/account/register">ユーザー登録</router-link>  </li>
        <li> <router-link to="/help/account/login">ログイン</router-link> </li>
        <li> <router-link to="/help/account/profile">アカウント設定</router-link> </li>
        <li> <router-link to="/help/account/backlink">バックリンク</router-link> </li>
        <li> <router-link to="/help/account/security">メールアドレス・パスワード変更</router-link> </li>
        <li> <router-link to="/help/account/guest">お試し登録</router-link> </li>
        <li> <router-link to="/help/account/resign">退会する</router-link> </li>
        <li> <router-link to="/help/account/pii">個人情報管理</router-link> </li>
    </ul>
</template>